<template>
  <div class="vertical-progress-flow">
    <div class="vertical-progress-flow_steps vcore_hidden--xs--down">
      <div
        v-for="(step, index) in filteredVerticalProgressSteps"
        class="vertical-progress-flow_step"
        :key="step.name"
        :style="{ top: step.offsetTop + 'px', 'z-index': 999 - index }"
      >
        {{ step.stepIndex + 1 }}
        <div
          class="vertical-progress-flow_step_connector"
          v-if="index !== 0"
          :style="{ height: calculateConnectorHeight(index) + 'px' }"
        ></div>
      </div>
    </div>
    <div class="vertical-progress-flow_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@Shared/utils/event-bus";
import { scrollToElement } from "@Shared/utils/Scroll";

export default {
  name: "VerticalProgressFlow",
  data() {
    return {
      verticalProgressSteps: [],
      previousStepOffset: 0,
    };
  },
  computed: {
    ...mapGetters([
      "enrollmentCurrentSearchStepIndex",
      "selectedProvider",
      "searchedProviders",
    ]),
    filteredVerticalProgressSteps() {
      return this.verticalProgressSteps.filter(
        (step, index) => step.stepIndex <= this.enrollmentCurrentSearchStepIndex && index <= this.enrollmentCurrentSearchStepIndex
      );
    },
  },
  watch: {
    selectedProvider() {
      setTimeout(() => {
        EventBus.$emit("update-offset");
      }, 700);
    },
    searchedProviders() {
      setTimeout(() => {
        EventBus.$emit("update-offset");
      }, 700);
    },
    enrollmentCurrentSearchStepIndex() {
      let elem;
      // if (val === 1) {
      elem = document.getElementById(
        this.verticalProgressSteps[this.enrollmentCurrentSearchStepIndex - 1].id
      );
      // } else {
      //   elem = document.getElementById(this.verticalProgressSteps[this.enrollmentCurrentSearchStepIndex].id);
      // }
      scrollToElement(elem, 700);
    },
  },
  methods: {
    calculateConnectorHeight(index) {
      return (
        this.verticalProgressSteps[index].offsetTop -
        this.verticalProgressSteps[index - 1].offsetTop
      );
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
  },
  provide() {
    return {
      verticalProgressSteps: this.verticalProgressSteps,
    };
  },
};
</script>

<style lang="scss" scoped>
.vertical-progress-flow {
  position: relative;
  margin-top: 27px;
}

.vertical-progress-flow_steps {
  position: absolute;
  top: 0;
  left: -68px;
  bottom: 0;
}

.vertical-progress-flow_step {
  color: $color_dark-blue;
  font-size: 24px;
  line-height: 46px;
  font-weight: bold;
  text-align: center;
  height: 50px;
  width: 50px;
  background-color: #ffffff;
  border: 2px solid $color_dark-blue;
  border-radius: 50%;
  position: absolute;
  transition: top 0.5s;
}

.vertical-progress-flow_step_connector {
  width: 5px;
  height: 0;
  background-color: #88bfd4;
  position: absolute;
  bottom: 48px;
  /*top: 48px;*/
  left: 21px;
  z-index: -1;
  transition: height 0.5s 0.5s;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
